// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 PRO React examples
import TransparentTeamCard from "examples/Cards/TeamCards/TransparentTeamCard";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

// Images
import team1 from "assets/images/bruce-mars.jpg";
import team2 from "assets/images/team-3.jpg";
import team3 from "assets/images/team-4.jpg";
import megaLogo from "assets/images/mega-logo.png";
import kadLogo from "assets/images/kad-logo.png";
import spooniLogo from "assets/images/spooni-logo.png";

function Team1() {
  const socialIcons = (
    <>
      <Tooltip placement="top" title="Follow me!">
        <MKBox
          component="i"
          fontSize="1.125rem"
          className="fab fa-twitter"
          sx={{
            color: ({ palette: { socialMediaColors } }) => socialMediaColors.twitter.main,
            cursor: "pointer",
          }}
        />
      </Tooltip>
      <Tooltip placement="top" title="Follow me!">
        <MKBox
          component="i"
          fontSize="1.125rem"
          className="fab fa-dribbble"
          sx={{
            color: ({ palette: { socialMediaColors } }) => socialMediaColors.dribbble.main,
            cursor: "pointer",
          }}
        />
      </Tooltip>
      <Tooltip placement="top" title="Follow me!">
        <MKBox
          component="i"
          fontSize="1.125rem"
          className="fab fa-linkedin"
          sx={{
            color: ({ palette: { socialMediaColors } }) => socialMediaColors.linkedin.main,
            cursor: "pointer",
          }}
        />
      </Tooltip>
    </>
  );

  return (
    <MKBox component="section" py={6}>
      <Container>
        <Grid container item flexDirection="column" xs={12} lg={7} mb={6}>
          <MKBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="3rem"
            height="3rem"
            variant="gradient"
            bgColor="info"
            color="white"
            shadow="md"
            borderRadius="lg"
            mb={2}
          >
            <BusinessCenterIcon />
          </MKBox>
          <MKTypography variant="h3" mb={1}>
            Business Partner
          </MKTypography>
          <MKTypography variant="body2" color="text">
            Spielsysteme, Mapping und alles drum herum, sind die Grundpfeiler eines jeden Servers. Wir haben uns mit den besten Partnern zusammengetan, um euch ein einzigartiges Spielerlebnis zu bieten.
          </MKTypography>
        </Grid>
        <Grid container spacing={3} mt={6}>
          <Grid item xs={12} md={6} lg={4}>
            <TransparentTeamCard
              image={megaLogo}
              name="Mega Development Services"
              position="Spielsysteme"
              description="Als ältester Partner und mittlerweile guter Freund, war Mega für einige grundlegende Systeme auf dem Projekt verantwortlich"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TransparentTeamCard
              image={kadLogo}
              name="Kad Darem"
              position="Spielsysteme"
              description="Spielsysteme von höchster Qualität und einem hohen Standard, welcher sich in der Community bewährt hat."
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TransparentTeamCard
              image={spooniLogo}
              name="Spooni"
              position="Mapping"
              description="Alles Rund um das Thema Mapping, ist bei Spooni in den besten Händen und so setzen auch wir auf eine enge Zusammenarbeit."
              
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team1;